import React from 'react';
import { MediafileItemSkeleton } from '@entities/media';
import MediafileItemAdapter from '../MediafileItemAdapter';
import type { DraggableVideoMediafilePreviewItemProps } from './types';

const PreviewItem: React.FC<DraggableVideoMediafilePreviewItemProps> = ({
  file,
  className,
  leading,
  onSetDuration,
  onDraftDurationChange,
  onRemoveMediafile,
  onCopyMediafile,
  onPreview,
  isBlockedDurationEdit,
}) =>
  file ? (
    <MediafileItemAdapter
      file={file}
      className={className}
      leading={leading}
      onSetDuration={onSetDuration}
      onDraftDurationChange={onDraftDurationChange}
      onRemoveMediafile={onRemoveMediafile}
      onCopyMediafile={onCopyMediafile}
      onPreview={onPreview}
      isBlockedDurationEdit={isBlockedDurationEdit}
    />
  ) : (
    <MediafileItemSkeleton className={className} />
  );

export default PreviewItem;
